import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-41bb87c0")
const _hoisted_1 = {
  class: "page p-jc-center",
  style: {"min-height":"50vh"}
}
const _hoisted_2 = { class: "p-d-flex p-jc-center" }
const _hoisted_3 = { class: "p-d-flex pi-ai-center" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Pianificazione taker ")
const _hoisted_5 = { class: "p-formgrid p-fluid" }
const _hoisted_6 = { class: "p-col-12" }
const _hoisted_7 = { class: "p-col-12" }
const _hoisted_8 = { class: "p-col-12" }
const _hoisted_9 = { class: "p-col-12" }
const _hoisted_10 = { class: "p-fluid" }
const _hoisted_11 = { class: "p-col-12 p-relative" }
const _hoisted_12 = ["required"]
const _hoisted_13 = { class: "p-col-12" }
const _hoisted_14 = { class: "p-fluid" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_ZoneAutocomplete = _resolveComponent("ZoneAutocomplete")!
  const _component_TakerAutocomplete = _resolveComponent("TakerAutocomplete")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TimeslotSelect = _resolveComponent("TimeslotSelect")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      _createVNode(_component_Card, { style: {"min-width":"360px"} }, {
        title: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_BackButton, {
              to: _ctx.backRoute,
              class: "p-mr-3"
            }, null, 8, ["to"]),
            _hoisted_4
          ])
        ]),
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_FloatLabel, { label: "Giorno" }, {
                default: _withCtx(() => [
                  _createVNode(_component_Calendar, {
                    modelValue: _ctx.date,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.date = $event)),
                    placeholder: "Seleziona giorno",
                    showIcon: "",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_FloatLabel, { label: "Città" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ZoneAutocomplete, {
                    modelValue: _ctx.zone,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.zone = $event)),
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_FloatLabel, { label: "Taker" }, {
                default: _withCtx(() => [
                  _createVNode(_component_TakerAutocomplete, {
                    modelValue: _ctx.taker,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.taker = $event)),
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_Button, {
                  label: "VISUALIZZA",
                  icon: "pi pi-eye",
                  class: "p-ml-auto",
                  disabled: _ctx.requestPending,
                  onClick: _ctx.onView
                }, null, 8, ["disabled", "onClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_TimeslotSelect, {
                modelValue: _ctx.shiftId,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.shiftId = $event)),
                required: ""
              }, null, 8, ["modelValue"]),
              _withDirectives(_createElementVNode("input", {
                required: !_ctx.isReadonly,
                type: "number",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.shiftId = $event)),
                class: "fake_input",
                tabindex: "-1"
              }, null, 8, _hoisted_12), [
                [_vModelText, _ctx.shiftId]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_Button, {
                  label: "MODIFICA",
                  icon: "pi pi-pencil",
                  class: "p-ml-auto",
                  disabled: _ctx.requestPending,
                  onClick: _ctx.onEdit
                }, null, 8, ["disabled", "onClick"])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}